import {
  DataTableOptions,
  useI18n,
} from "@/composables";

import {
  defaultFetch,
  httpMethod,
} from "@/scripts/Common/api";

import {
  getToken,
  PaginationRequest,
} from "@/scripts/Common";

import {
  Ref,
} from "vue";

const fetchIssuerCards = async (issuerId: number, options: Ref<DataTableOptions>, cardNumberFilter: string | undefined) => {

  options.value.loading = true;

  const {
    error,
    paginationCount,
    totalItemCount,
    response,
  } = await defaultFetch({
    apiName: 'getIssuerCardList',
    bearer: getToken(),
    options: {
      query: {
        issuerId: issuerId,
        pageNumber: (options.value.pagination.page - 1).toString(),
        pageSize: options.value.pagination.itemsPerPage,
        cardNumber: cardNumberFilter,
        sortColumn: options.value.sorting.sortBy,
        sortDirection: options.value.sorting.sortDesc ? 'desc' : 'asc'
      }
    }
  });

  options.value.loading = false;
  options.value.pagination.pageCount = paginationCount ?? 0;
  options.value.pagination.totalItemCount = totalItemCount ?? 0;

  return {
    error,
    paginationCount,
    totalItemCount,
    response
  }
}

const loadLastWebchargeStateForCards = async (cardNumbers: number[], paginationRequest: PaginationRequest) => {
  const {
    error,
    response,
  } = await defaultFetch({
    apiName: 'getWebchargeStates',
    bearer: getToken(),
    options: {
      method: httpMethod.GET,
      query: {
        cardNumbers: cardNumbers,
        pageNumber: (paginationRequest.page - 1),
        pageSize: paginationRequest.itemsPerPage,
      }
    }
  });

  return {
    error,
    response
  }
}

const importIssuerCards = async (file: any) => {
  const formData = new FormData();
  formData.append('file', file)

  const {locale} = useI18n();

  const {
    error,
    response,
  } = await defaultFetch({
    apiName: 'importCards',
    bearer: getToken(),
    options: {
      method: httpMethod.PUT,
      headers: {
        'Content-Type': 'text/csv',
        'Authorization': `Bearer ${getToken()}`,
        'Accept-Language': locale.value
      }
    },
    body: file,
  });

  return {
    error,
    response
  }
}

const updateOrCreateIssuerCardList = async (method: httpMethod, cardNumbers: number[], issuerId: number) => {
  const {
    error,
    response,
  } = await defaultFetch({
    apiName: 'updateOrCreateIssuerCards',
    bearer: getToken(),
    options: {
      method,
    },
    body: JSON.stringify({
      cardNumberList: cardNumbers,
      issuerId: issuerId
    }),
  });

  return {
    error,
    response
  }
}

const deleteIssuerCard = async (cardNumbers: number[], issuerId: number)=>
{
  const {
    error,
    response,
  } = await defaultFetch({
    apiName: 'deleteIssuerCards',
    bearer: getToken(),
    options: {
      method: httpMethod.POST
    },
    body: JSON.stringify({
      cardNumberList: cardNumbers,
      issuerId: issuerId
    }),
  });

  return {
    error,
    response
  }
}

export {
  fetchIssuerCards,
  loadLastWebchargeStateForCards,
  importIssuerCards,
  updateOrCreateIssuerCardList,
  deleteIssuerCard
}
